<template>
    <tile class="inspections" link="inspections">
        <div slot="tileHeader">
            <tile-title icon="bolt">Проверки</tile-title>
        </div>
        <div slot="tileContent">
            <div v-if="auth" class="inspections__content" >
                <left-transition :isShow="years.length > 0 && contentType === 'table'">
                    <div ref="htmlContent">
                        <inspections-table
                            :years="sorted_years" 
                            :data="inspections"
                            class="inspections__table" 
                        />
                    </div>
                </left-transition>
                <right-transition :isShow="years.length > 0 && contentType === 'chart'">
                    <chart />
                </right-transition>
                <inspections-modal v-if="isModal" />
            </div>
            <demo-message v-else />
        </div>
        <div class="inspections__footer" slot="tileFooter">
            <app-switcher
                :leftClickHandler="() => contentType = 'table'"
                :rightClickHandler="() => contentType = 'chart'"
            >
                <span slot="leftValue">Таблица</span>
                <span slot="rightValue">График</span>
            </app-switcher>
            <tilePrintPdf
                :html="htmlForPrint"
                :title="title"
                :printStyle="printStyle"
                filename="inspections"
            />
        </div>
    </tile>
</template>

<script>
import tile from '@/components/ui/tile/tile.vue'
import tilePrintPdf from '@/components/ui/tilePrintPdf/tilePrintPdf.vue'
import appSwitcher from '@/components/ui/appSwitcher/appSwitcher.vue'
import tileTitle from '@/components/ui/tileTitle/tileTitle.vue'
import demoMessage from '@/components/ui/demoMessage/demoMessage.vue'
import inspectionsTable from '@/components/card/inspections/inspectionsTable.vue'
import inspectionsModal from '@/components/card/inspections/inspectionsModal.vue'
import chart from '@/components/card/inspections/inspectionsChart.vue'
import leftTransition from '@/components/ui/tileTransition/leftTransition.vue'
import rightTransition from '@/components/ui/tileTransition/rightTransition.vue'

export default {
    components: {
        tile, 
        tilePrintPdf,
        appSwitcher,
        tileTitle,
        demoMessage,
        inspectionsTable,
        inspectionsModal,
        chart,
        leftTransition,
        rightTransition
    },
    data: () => ({
        contentType: 'table',
        htmlForPrint: '',
        printStyle: `
            .print-main-title { 
                    border-bottom: 1px solid #4b6365;
                    color: #4b6365;
                    font-size: 25px;
                    margin-top: 0px;
                    margin-bottom: 0px;
                    text-align: center;
                    margin-bottom: 15px;
                    margin-top: 20px; 
            }
            button.btn { background: none !important; border: none;}
            .inspections-table th { background: #ddddde !important; }
            .inspections-table th, .inspections-table td  { padding: 8px; }
            td.right { border-right: none; text-align: right; }
            td.left { border-left: none; text-align: left; }
            .last-row td, .last-row td.first-column .btn { font-weight: 700; }
        `
    }),
    computed: {
        inspections() { return this.$store.state?.card?.inspections?.inspectionStatistic },
        sorted_years() { return this.years.slice().sort((a,b) => b- a)},
        years() { return this.$store.getters['card/inspections/years'] },
        auth() { return this.$store.state?.user?.auth },
        isModal() { return this.$store.state?.card?.inspections?.isModal },
        companyName() {
            if(this.type === 'ip') {
                return this.$store.state.card?.company?.head_fio ? `ИП ${this.$store.state.card?.company?.head_fio}` : this.$store.state.card?.company?.title
            } else {
                return this.$store.state?.card?.company?.name_short || this.$store.state?.card?.company?.name_full
            }
        },
        type() { return this.$store.state.card?.company?.type },
        title() { return `Проверки | ${this.companyName}` },
        totalAmount() { return this.inspections.total.plan.amount + this.inspections.total.notplan.amount }
    },
    methods: {
        getInspections() {
            this.$store.dispatch('card/inspections/fetchInspections')
                .finally(() => {
                    if(!this.inspections) {
                        $('#inspections-label').text('Проверки отсутствуют')
                        $('#inspections-tile').hide()
                        $('tiles').trigger('resize')
                    } else {
                        this.htmlForPrint = this.$refs.htmlContent?.innerHTML
                        $('#inspections-label').html(`
                            <a href="#inspections-tile-link">Найдено ${this.totalAmount} проверок</a>
                        `)
                        $('#sliders-item-inspections').find('span').text(`Проверки (${this.totalAmount})`)
                        $('#widemenu-item-inspections').text(`Проверки (${this.totalAmount})`)
                    }
                })
        },
        
    },
    mounted() {
        this.getInspections()
    }
}
</script>
<style lang="sass" scoped>
@import 'styles/global-variables'

.inspections
    &__footer
        @include flex-between()
        span
            font-weight: 300
</style>
